import { CommonModule } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { ProductStockChartDiagramComponent } from '../../../warehouse/modules/product-stock-chart-diagram/product-stock-chart-diagram.component';
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { DliProductGetManySearchInput, Operator, Product, ProductType, ProductUnitConversionLink, SearchInput } from '../../../../generated/generated-types';
import { ProductDropDownComponent } from '../../../products/modules/product-chooser/product-dropdown.component';
import { ProductService } from '../../../products/services/product.service';
import { DocumentLineItemService } from '../../services/document-line-item.service';

@Component({
  selector: 'app-dli-product-dropdown',
  templateUrl: '../../../products/modules/product-chooser/product-dropdown.component.html',
  styleUrls: ['../../../products/modules/product-chooser/product-dropdown.component.scss'],
  providers: [ProductService],
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
    ProductStockChartDiagramComponent,
  ],
})
export class DliProductDropDownComponent extends ProductDropDownComponent {

  @Input()
  addressId?: string;

  @Input()
  documentId?: string;

  @Input()
  excludeTradingSetProducts = false;

  productUnitConversionLinks: ProductUnitConversionLink[] = [];
  lastSearchProducts: Product[] = [];

  constructor(
    @Self() service: ProductService,
    private dliService: DocumentLineItemService,
  ) {
    super(service);
  }

  override async executeSearch(searchInput: SearchInput, options?: ICRUDOptions) {
    if (this.excludeTradingSetProducts) {
      applySearchRule(searchInput, {
        rules: [
          {
            field: 'productType',
            operator: Operator.notequal,
            value: ProductType.TRADINGSET,
            type: 'enum',
          },
        ],
      });
    }

    const input = {
      ...(searchInput as DliProductGetManySearchInput),
      addressId: this.addressId,
      documentId: this.documentId,
    } as DliProductGetManySearchInput & { documentId?: string };
    const result = await this.dliService.dliProductGetManyData(input);
    this.productUnitConversionLinks = result.productUnitConversionLinks ?? [];

    if (this.productUnitConversionLinks.length > 0) {
      const products = this.getProductsFromConversionLinks(this.productUnitConversionLinks);
      this.lastSearchProducts = products;
      return {
        result: products,
        count: products.length,
        isLastPage: true,
      };
    }

    this.lastSearchProducts = result.productResult?.items ?? [];
    return {
      result: this.lastSearchProducts,
      count: result.productResult?.totalItems ?? 0,
      isLastPage: result.productResult?.isLastPage ?? true,
    };
  }

  private getProductsFromConversionLinks(links: ProductUnitConversionLink[]): Product[] {
    const byId = new Map<string, Product>();
    for (const link of links) {
      if (link.product?.id)
        byId.set(link.product.id, link.product);
    }
    return [...byId.values()];
  }
}
